import type { ChangelogEntry } from "../types";

/**
 * Andre del av tilbudsarbeidsrommet: Idé-tavlen.
 * Bak funksjonsbryteren «Tilbudsarbeidsrom».
 */
export const TILBUDSARBEIDSROM_IDE_2026_10: ChangelogEntry = {
  id: "2026-10-27-tilbudsarbeidsrom-ide",
  date: "2026-10-27",
  title: "Idé-tavle på tilbudet, der et kort kan bli en budsjettlinje",
  summary: "Grenen Idé er en tavle for notater, bilder, lenker, referansefilmer, åpne spørsmål og sitater fra kundekortet.",
  sections: [
    {
      heading: "Tilbud",
      items: [
        {
          title: "Idé-tavle med kort og grupper",
          kind: "nytt",
          featureFlag: "feature_offer_workspace",
          body: "Lag notater, bilder, lenker, referansefilmer og åpne spørsmål på tavlen, flytt dem fritt og samle dem i grupper. Plasseringen lagres på tilbudet. Dra et referat fra kundekortet inn på tavlen for å få et sitatkort med kilde og dato. Slettede kort kan hentes tilbake med «Angre». Tavlen er intern og vises aldri for kunden.",
        },
        {
          title: "Fra idé til budsjettlinje",
          kind: "nytt",
          featureFlag: "feature_offer_workspace",
          body: "«Lag budsjettlinje» på et kort åpner katalogen og legger linjen i budsjettet med kortets tekst som kommentar. Linjen viser «Fra idé», og kortet merkes «Budsjett».",
        },
      ],
    },
  ],
};
